const TOAST_DEDUP_MS = 200;
const recentToastKeys = new Map();

let toastListeners = new Set();
let toastItems = [];

const emit = () => {
  toastListeners.forEach((listener) => listener([...toastItems]));
};

export const subscribeCpanelToasts = (listener) => {
  toastListeners.add(listener);
  listener([...toastItems]);
  return () => {
    toastListeners.delete(listener);
  };
};

export const dismissCpanelToast = (toastId) => {
  toastItems = toastItems.filter((item) => item.toastId !== toastId);
  emit();
};

export const showCpanelToast = ({
  toastId,
  title,
  message = '',
  url = null,
  linkText = 'Buka',
  theme = 'success',
  duration = 5000,
}) => {
  const dedupeKey = toastId || `${title}-${message}-${theme}`;
  const now = Date.now();
  const lastShown = recentToastKeys.get(dedupeKey);
  if (lastShown && now - lastShown < TOAST_DEDUP_MS) {
    return;
  }
  recentToastKeys.set(dedupeKey, now);
  setTimeout(() => recentToastKeys.delete(dedupeKey), TOAST_DEDUP_MS);

  const id = toastId || `toast-${now}-${Math.random().toString(36).slice(2, 9)}`;
  toastItems = [{ toastId: id, title, message, url, linkText, theme, duration }, ...toastItems].slice(
    0,
    6
  );
  emit();

  if (duration > 0) {
    window.setTimeout(() => dismissCpanelToast(id), duration);
  }
};

export const mapNotificationToToast = (notification) => {
  const inProgress =
    notification.type === 'job.started' || notification.data?.status === 'running';
  let theme = 'success';
  if (notification.type === 'job.failed' || notification.data?.icon === 'danger') {
    theme = 'danger';
  } else if (inProgress) {
    theme = 'info';
  }

  return {
    toastId: `notif-toast-${notification.id}`,
    title: notification.title || 'Notifikasi',
    message: notification.body || '',
    url: notification.url || null,
    linkText: notification.url ? 'Lihat detail' : undefined,
    theme,
  };
};

export const resetCpanelToastState = () => {
  toastItems = [];
  recentToastKeys.clear();
  emit();
};
